var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"customers-add"},[_c('h2',{staticClass:"subtitle"},[_vm._v(_vm._s(this.record.text))]),_c('div',{domProps:{"innerHTML":_vm._s(this.record.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }